import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { EcoDocumentSearch } from '../../../services/eco-document-search/eco-document-search.model';

@Injectable({ providedIn: 'root' })
export class EcoDocumentSearchService {
  private filtersSubject = new BehaviorSubject<EcoDocumentSearch>(null);
  filters$ = this.filtersSubject.asObservable();
  private formValue: EcoDocumentSearch | null = null;

  setFilters(filters: any): void {
    this.filtersSubject.next(filters);
  }

  getFilters(): EcoDocumentSearch {
    return this.filtersSubject.value;
  }

  setFormValue(value: EcoDocumentSearch): void {
    this.formValue = value;
  }

  getFormValue(): EcoDocumentSearch | null {
    return this.formValue;
  }
}
